import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import type { ApiState } from '@comparit/core';

/**
 * "Zum Antrag" call to action of the Tarifdetails page: disabled with a spinner while price and
 * documents are being fetched, enabled on success, and not rendered at all on error (the
 * documents box explains the failure; a reload runs get-order again).
 */
@Component({
  selector: 'ui-tarifdetails-cta',
  templateUrl: './tarifdetails-cta.component.html',
  styleUrl: './tarifdetails-cta.component.scss',
  imports: [MatProgressSpinnerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class TarifdetailsCtaComponent {
  /** State of the get-order step; `success` unlocks the Antrag. */
  readonly state = input.required<ApiState<unknown>['state']>();

  readonly antrag = output<void>();
}
